import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Delete", 
  message = "Are you sure you want to delete this item?",
  confirmText = "Delete",
  cancelText = "Cancel",
  type = "danger" // danger, warning, info
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const getIconAndColor = () => {
    switch (type) {
      case 'danger':
        return { icon: '🗑️', color: 'danger' };
      case 'warning':
        return { icon: '⚠️', color: 'warning' };
      case 'info':
        return { icon: 'ℹ️', color: 'info' };
      default:
        return { icon: '❓', color: 'info' };
    }
  };

  const { icon, color } = getIconAndColor();

  return (
    <div className="confirmation-modal-overlay" onClick={handleBackdropClick}>
      <div className="confirmation-modal-container">
        <div className="confirmation-modal-content">
          <div className={`confirmation-modal-icon ${color}`}>
            {icon}
          </div>
          
          <div className="confirmation-modal-text">
            <h3 className="confirmation-modal-title">{title}</h3>
            <p className="confirmation-modal-message">{message}</p>
          </div>
        </div>
        
        <div className="confirmation-modal-actions">
          <button 
            onClick={onClose} 
            className="confirmation-modal-btn cancel"
          >
            {cancelText}
          </button>
          <button 
            onClick={handleConfirm} 
            className={`confirmation-modal-btn confirm ${color}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
